/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetSessionStatus200Response
 */
export interface GetSessionStatus200Response {
    /**
     * HTTP 세션 존재 여부
     * @type {boolean}
     * @memberof GetSessionStatus200Response
     */
    'hasSession'?: boolean;
    /**
     * 세션 ID (세션이 있는 경우)
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'sessionId'?: string;
    /**
     * 세션 생성 시간 (밀리초)
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'creationTime'?: string;
    /**
     * 마지막 접근 시간 (밀리초)
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'lastAccessedTime'?: string;
    /**
     * 세션 최대 유지 시간 (초)
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'maxInactiveInterval'?: string;
    /**
     * 새로 생성된 세션 여부
     * @type {boolean}
     * @memberof GetSessionStatus200Response
     */
    'isNew'?: boolean;
    /**
     * 세션에 저장된 사용자 ID
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'userId'?: string;
    /**
     * 세션에 저장된 사용자 이메일
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'userEmail'?: string;
    /**
     * 세션 인증 상태
     * @type {boolean}
     * @memberof GetSessionStatus200Response
     */
    'authenticated'?: boolean;
    /**
     * JWT 토큰 인증 상태
     * @type {boolean}
     * @memberof GetSessionStatus200Response
     */
    'jwtAuthenticated'?: boolean;
    /**
     * JWT 토큰의 사용자 ID
     * @type {string}
     * @memberof GetSessionStatus200Response
     */
    'jwtUserId'?: string;
}

